/**
 * This mixin is for components that have the Context component as root element.
 * It will make it easier to call the root context specific functions.
 */
export default {
  methods: {
    getRootContext() {
      // Search in the refs
      if (this.$refs.context) {
        return this.$refs.context
      }

      // Nothing rather than an error, the same answer `modal.js` gives: a
      // component can be gone by the time an awaited call comes back to hide
      // it, and the guards below already read this as "there is nothing to
      // hide". Throwing here turned that into an unhandled rejection instead.
      return null
    },
    toggle(...args) {
      const context = this.getRootContext()
      context && context.toggle(...args)
    },
    toggleNextToMouse(...args) {
      const context = this.getRootContext()
      context && context.toggleNextToMouse(...args)
    },
    show(...args) {
      const context = this.getRootContext()
      context && context.show(...args)
    },
    showNextToMouse(...args) {
      const context = this.getRootContext()
      context && context.showNextToMouse(...args)
    },
    hide(...args) {
      const context = this.getRootContext()
      context && context.hide(...args)
    },
  },
}
